import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class BillingServiceService {
    public workSpaceURL = environment.workspaceApiUrl + 'api/v1/';
    professionalPlan: any;
    private is_Upgrade$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private is_Expire_Remaining_Notify$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private is_Expire_Notify$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    constructor(private httpClient: HttpClient) { }



    set_is_Expire_Notify(flag: boolean) {
        this.is_Expire_Notify$.next(flag);
    }

    get_is_Expire_Notify(): Observable<boolean> {
        return this.is_Expire_Notify$.asObservable();
    }


    set_is_Expire_Remaining_Notify(flag: boolean) {
        this.is_Expire_Remaining_Notify$.next(flag);
    }

    get_is_Expire_Remaining_Notify(): Observable<boolean> {
        return this.is_Expire_Remaining_Notify$.asObservable();
    }

    setIsUpgradePlan(flag: boolean) {
        this.is_Upgrade$.next(flag);
    }

    getIsUpgradePlan(): Observable<boolean> {
        return this.is_Upgrade$.asObservable();
    }

    getBillingPlans(url: string) {
        return this.httpClient.get(this.workSpaceURL + url);
    }

    sendStripeToken(
        stripeToken: any,
        price_id: string,
        subscription_kuid: string,
        checkOutType: string,
        customerId?: string
    ): Observable<any> {
        const url = this.workSpaceURL + 'subscription/checkout';
        return this.httpClient.post<any>(url, {
            payload: JSON.stringify({
                token: stripeToken,
                price_id: price_id,
                subscription_kuid: subscription_kuid,
                checkout_type: checkOutType,
                customer_id: customerId
            }),
        });
    }


    onboardingCardDetails(
        stripeToken: any,
        subscriptionKuid: string,
        priceId: string,
        checkoutType: string,
        customerId: string
    ): Observable<any> {

        const url = this.workSpaceURL + '/billing/payment-methods/trial';

        return this.httpClient.post<any>(url, {
            payload: JSON.stringify({
                token: stripeToken,
                subscription_kuid: subscriptionKuid,
                price_id: priceId,
                checkout_type: checkoutType,
                customerId
            })
        });
    }

    getBillingHistory() {
        const url = this.workSpaceURL + 'subscription/user-billings';
        return this.httpClient.post<any>(url, '');
    }
    getBillingHistoryDetails(payload: any) {
        const url = this.workSpaceURL + 'subscription/user-billings';
        return this.httpClient.post<any>(url, payload);
    }

    billingDetails() {
        const url = this.workSpaceURL + 'user/billing-details';
        return this.httpClient.get(url);
    }
    selectedPlanData(payload: any) {
        const url = this.workSpaceURL + 'selected-subscription-plan';
        return this.httpClient.post<any>(url, payload);
    }
    processPayment(payload: any) {
        return this.httpClient.post('/api/payment-intent', payload); // Replace with your API endpoint
    }

    updateCard(stripeToken: any, customerId: string): Observable<any> {
        const url = this.workSpaceURL + '/subscription/update-card';
        return this.httpClient.post<any>(url, {
            payload: JSON.stringify({
                token: stripeToken,
                customerId
            }),
        });
    }
    cancelSubscriptionReason(
        reason: string,
        description: string
    ): Observable<any> {
        const url = this.workSpaceURL + '/subscription/cancelSubscriptionReason';
        return this.httpClient.post<any>(url, {
            payload: JSON.stringify({
                commentTitle: reason,
                commentDescription: description,
            }),
        });
    }
    verifyOtp(otp: any): Observable<any> {
        const url = this.workSpaceURL + '/subscription/verifyOtp';
        return this.httpClient.post<any>(url, {
            payload: JSON.stringify({
                otp: otp,
            }),
        });
    }
    cancelSubscription(ws_kuid: any, p_kuid): Observable<any> {
        const url = this.workSpaceURL + '/subscription/cancel';
        return this.httpClient.post<any>(url, {
            payload: JSON.stringify({
                workspace_kuid: ws_kuid,
                project_kuid: p_kuid,
                pg: 0,
            }),
        });
    }

    stripeSetupIntent(body: any): Observable<any> {
        const url = this.workSpaceURL + '/setup-intent/create';
        return this.httpClient.post<any>(url, { payload: JSON.stringify(body) });
    }
}
